export default "__VITE_ASSET__DrZIzYWh__"